<div class="header">
    <div class="step-counter">Step {{state()?.stepNumber}} of {{state()?.stepCount}}</div>
    <h2 class="step-title">{{title()}}</h2>
    <div class="step-description">{{description()}}</div>
</div>
